import { render, staticRenderFns } from "./ImportsValidate.vue?vue&type=template&id=3caa6525&scoped=true"
import script from "./ImportsValidate.vue?vue&type=script&lang=js"
export * from "./ImportsValidate.vue?vue&type=script&lang=js"
import style0 from "./ImportsValidate.vue?vue&type=style&index=0&id=3caa6525&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caa6525",
  null
  
)

export default component.exports